import React, { useEffect } from 'react';
import MedicalSchoolLandingPage from '../../features/specialty/medicalschool';

export default function MedicalSchoolLandingRoute() {
  useEffect(() => {
    document.title = "IVORI — Medical School Interview Prep";
    window.scrollTo(0, 0);
  }, []);

  return <MedicalSchoolLandingPage />;
}
